import { useContext } from "react";
import { OfflineDetectContext } from "./OfflineDetectContext";
import { OfflineDetectState, OfflineDetectAction } from "./OfflineDetectContextTypes";

export function useOfflineDetectContext() {
    const context = useContext<[OfflineDetectState, (action: OfflineDetectAction) => void] | undefined>(OfflineDetectContext);
    if (!context) {
        throw new Error("useOfflineDetectContext must be used within an OfflineDetectContextProvider");
    }
    return context;
}
